<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL Group" prop="aslGroupName">
                    <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="药品一级分类" prop="medicineLevelOneGrade">
                    <el-select v-model="queryCondition.medicineLevelOneGrade" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="WHO 分类" prop="medicineLevelTwoGrade">
                      <el-select v-model="queryCondition.medicineLevelTwoGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in medicineLevelTwoGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="WHO药品等级" prop="whoMedicineGrade">
                      <el-select v-model="queryCondition.whoMedicineGrade" clearable filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in whoMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="有效成分" prop="effectiveComponentsList">
                      <el-select v-model="queryCondition.effectiveComponentsList" filterable clearable multiple collapse-tags style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="top" v-if="item.name.length>20">
                            <span style="display:inline-block;width:300px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</span>
                          </el-tooltip>
                          <span style="display:inline-block;width:300px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;" v-else>{{ item.name }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="通用名" prop="commonName">
                      <el-input v-model="queryCondition.commonName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="商品名" prop="productName">
                      <el-input v-model="queryCondition.productName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="药品代码" prop="medicineCode">
                      <el-input v-model="queryCondition.medicineCode" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="药品状态" prop="medicineUseStatus">
                      <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="MEDICINE_USE_STATUS" clearable v-model="queryCondition.medicineUseStatus" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="审批状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable placeholder="请选择" style="width:100%" filterable class="multiple_sel">
                        <el-option :key="index" v-for="(item,index) in statusOption" :label="item.chineseValue" :value="item.code"></el-option>
                      </el-select>
                      <!-- <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="STATUS" clearable v-model="queryCondition.status"  style="width:100%"></ic-select> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_PROT_MEDICINE_ADD" class="btn" type="primary" @click="addList">新增</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_DELETE" class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_SUBMIT" class="btn" type="primary" @click="submit">提交</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_CONFIRM" class="btn" type="primary" @click="isUpdate">确认无更新</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_APPROVE" class="btn" type="primary" @click="approve">批准</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_RETURN" class="btn" type="primary" @click="sendBack">退回</el-button>
        <el-dropdown split-button type="primary" @click="handleClick" placement="bottom" style="margin-right: 10px;">
          报表
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" v-acl="RMC_PROT_MEDICINE_REPORT" class="dropdownItemBtn" @click="exportMedicine" type="primary">药品清单</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button size="mini" v-acl="RMC_PROT_MEDICINE_REPORT_QUR" class="dropdownItemBtn" @click="exportMedicineSnapshot" type="primary">药品清单(季度)</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-acl="RMC_PROT_MEDICINE_IMPORT" class="btn" type="primary" @click="importData">批量导入</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_HISTORY" class="btn" type="primary" @click="openHistory">查看历史</el-button>
        <el-button v-acl="RMC_PROT_MEDICINE_CHANGE_LOG" class="btn" type="primary" @click="updateLog">更新日志</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column fixed="left" align="center" type="checkbox" width="80" />
        <ux-table-column fixed="left" align="center" title="Category3" field="category3Name" width="120" />
        <ux-table-column fixed="left" align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="ASL Group" min-width="120" field="aslGroupName"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="药品代码" min-width="120" field="medicineCode"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="药品一级分类" min-width="140" field="medicineLevelOneGrade">
          <template v-slot="scope">
            <el-button type="text" @click="openDetail(scope.row)">{{scope.row.medicineLevelOneGrade}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column fixed="left" align="center" title="WHO分类" min-width="100" field="medicineLevelTwoGrade"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="WHO药品等级" min-width="120" field="whoMedicineGrade"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="OIE药物等级" min-width="100" field="oieMedicineGrade"></ux-table-column>
        <ux-table-column fixed="left" align="center" title="有效成分" min-width="120" field="effectiveComponents"></ux-table-column>
        <ux-table-column align="center" title="通用名" min-width="120" field="commonName"></ux-table-column>
        <ux-table-column align="center" title="商品名" min-width="120" field="productName"></ux-table-column>
        <ux-table-column align="center" title="兽药批准文号" min-width="120" field="approvelNumber"></ux-table-column>
        <ux-table-column align="center" title="有效成分和含量" min-width="120" field="effectiveComponentsContent"></ux-table-column>
        <ux-table-column align="center" title="适应症" min-width="120" field="indication"></ux-table-column>
        <ux-table-column align="center" title="生产厂家" min-width="120" field="producer"></ux-table-column>
        <ux-table-column align="center" title="规格" min-width="120" field="specification"></ux-table-column>
        <ux-table-column align="center" title="用法和用量" min-width="120" field="usage"></ux-table-column>
        <ux-table-column align="center" title="休药期(天)" min-width="120" field="withdrawalDay"></ux-table-column>
        <ux-table-column align="center" title="最新检测时间" min-width="120" field="lastDetectionTime"></ux-table-column>
        <ux-table-column align="center" title="检测报告" min-width="120" field="createDate">
          <template v-slot="scope">
            <el-button type="text" @click="onGrade(scope.row)">查看</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="修改原因" min-width="120" field="modifyReason"></ux-table-column>
        <ux-table-column align="center" title="药品在用状态" min-width="120" field="medicineUseStatusI18n"></ux-table-column>
        <ux-table-column align="center" title="养殖模式" min-width="120" field="breedingModeView"></ux-table-column>
        <ux-table-column align="center" title="状态" min-width="120" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="提交人" min-width="120" field="submitUser"></ux-table-column>
        <ux-table-column align="center" title="提交日期" min-width="120" field="submitDate"></ux-table-column>
        <ux-table-column align="center" title="审批通过日期" min-width="120" field="auditDate"></ux-table-column>

      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">更新日志</p>
          </div>
        </div>
        <updateDialog v-if="dialogVisible" @close="handleClose"></updateDialog>
      </el-dialog>

      <el-dialog title="" :visible.sync="fileleDialog" width="60%">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">检测报告</p>
          </div>
        </div>
        <fileleDialog v-if="fileleDialog" :fileList="fileList"></fileleDialog>
      </el-dialog>

      <el-dialog title="" :visible.sync="exportDialog" width="30%" :before-close="closeExportDialog">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">选择季度</p>
          </div>
        </div>
        <exportDialog v-if="exportDialog" @closeExport="closeExportDialog" :exportTitle="exportTitle" :exportType='exportType'></exportDialog>
      </el-dialog>

      <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
        <el-row style="margin-bottom:10px">
          <el-upload ref="batchUpload" :headers="header" :action="uploadListsUrl" :on-success="uploadListsSuccess" :on-change="handleChange" :before-upload="beforeListsUpload" :file-list="importFileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
            <el-button size="small" type="primary">选取文件</el-button>
          </el-upload>
          <!-- <el-link type="button" target="_blank" href="static/template/qspi/RMC_Protein_FeedFactory_Tpl.xlsx" download="RMC_Protein_FeedFactory_Tpl.xlsx"> -->
          <el-button class="btn" type="primary" size="small" style="height:100%" @click="downloadImportTem">导入模板下载</el-button>
          <!-- </el-link> -->
        </el-row>
        <el-form :model="uploadForm" ref="uploadForm">
          <el-form-item>
            <el-input v-model="uploadForm.fileName" readonly></el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <h4>说明:</h4>
          <ul>
            <li>1.请点击模板下载,按照模板填写后再上传</li>
            <li>2.模板中红色字段为必填项,请务必正确填写</li>
            <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
            <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
            <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
          </ul>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
        </el-row>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import apiService from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import proteinDrug from "@/api/rmcProtein/drug";
import fileleDialog from '@/components/page/RMC/Protein/rmcDrugList/dialog/fileleDialog'
import { fileService } from "@/api/common/file-utils";
import exportDialog from '@/components/page/RMC/Protein/rmcDrugList/dialog/exportDialog'
import prodMedicine from "@/api/rmcProduce/prodMedicine";
import moment from "moment";

export default {
  name: '',
  components: {
    updateDialog,
    IcSelect,
    fileleDialog,
    exportDialog
    // detailDialog
  },
  data() {
    return {
      exportType: "",
      uploadForm: {
        fileName: "",
      },
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      dialogBatchUploadVisible: false,
      exportDialog: false,
      fileList: [],
      importFileList: [],
      fileleDialog: false,
      effectiveComponentsList: [],
      medicineLevelOneGradeList: [],
      medicineLevelTwoGradeList: [],
      whoMedicineGradeList: [],
      oieMedicineGradeList: [],
      identity: localStorage.getItem('ms_emplFlag'),
      dialogVisible: false,
      allDate: [],
      multipleSelection: [],
      category3List: [],
      statusList: [],
      exportTitle: "",
      queryCondition: {
        category3Code: "",
        sponsorName: "",
        aslGroupName: "",
        medicineLevelOneGrade: "",
        medicineLevelTwoGrade: "",
        whoMedicineGrade: "",
        effectiveComponentsList: [],
        medicineCode:"",
        commonName: "",
        productName: "",
        medicineUseStatus: "INUSE",
        status: "",
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      totalCount: "",
      statusView: "",
      identity: localStorage.getItem('ms_emplFlag'),
      statusOption: [],
      ms_roles: JSON.parse(localStorage.getItem('ms_roles')),

    }
  },
  created() {
    let qspiInfo = JSON.parse(sessionStorage.getItem('qspiInfo'))
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    }
    let queryData = this.$store.state.asl.skipQuery
    if (qspiInfo) {
      if (qspiInfo.type == 'RMC_PROTEIN_MEDICINE_UPDATE') {  //待供应商更新
        this.$set(this.queryCondition, 'medicineUseStatus', 'INUSE')
      } else {
        this.$set(this.queryCondition, 'medicineUseStatus', '')
      }
      if (qspiInfo.SPONSOR_NAME) {
        this.$set(this.queryCondition, 'sponsorName', qspiInfo.SPONSOR_NAME)
      }
      if (qspiInfo.AUDIT_STATUS) {
        this.$set(this.queryCondition, 'status', qspiInfo.AUDIT_STATUS)
      }
    }
    // if(queryData.sponsorName){
    //   this.$set(this.queryCondition,'sponsorName',queryData.sponsorName)
    // }
    // if(queryData.category3Code){
    //   this.$set(this.queryCondition,'category3Code',queryData.category3Code)
    // }
    if (queryData.aslGroupName) {
      this.$set(this.queryCondition, 'medicineUseStatus', "")
      this.$set(this.queryCondition, 'aslGroupName', queryData.aslGroupName)
    }
    this.getStatusList()
    this.getDrugGrade()
    this.queryData();
    this.getdCategory3()
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
    sessionStorage.setItem('qspiInfo', null)
  },
  computed: {
    uploadListsUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `rmc/protein/medicine/importExcelForProteinMedicine`;
    },
  },
  methods: {
    getStatusList() {
      prodMedicine.getStatusList({
        "TT_RMC_PROTEIN_MEDICINE:STATUS": "TT_RMC_PROTEIN_MEDICINE:STATUS",
      }).then((res) => {
        if (this.ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS') !== -1) {
          this.statusOption = res["TT_RMC_PROTEIN_MEDICINE:STATUS"].filter(ele => {
            return ele.code != "DRAFT"
          })
        } else {
          this.statusOption = res["TT_RMC_PROTEIN_MEDICINE:STATUS"];
        }
      })
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      proteinDrug.getDrugList(this.queryCondition).then((res) => {
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
    },
    openDetail(row) {
      this.$router.push({
        path: "/rmcProtMedicine/detail",
        query: {
          id: row.ttRmcProteinMedicineId
        }
      })
    },
    openHistory() {
      let drugId = []
      this.multipleSelection.forEach((v) => {
        drugId.push(v.ttRmcProteinMedicineId)
      })
      sessionStorage.setItem('drugId', JSON.stringify(drugId))
      this.$router.push({
        path: "/drugHistory",
        query: {

        }
      })

    },
    downloadImportTem() {
      proteinDrug.importExcelForProteinMedicineTemp().then((res) => {
        fileService.respToFile(res, 'RMC_Protein_药品清单导入模板.xlsx');
      })
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.importFileList = []
    },
    beforeListsUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.importFileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    uploadListsSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      this.dialogBatchUploadVisible = false
      this.importFileList = []
      this.uploadForm.fileName = ''
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
    },
    updateLog() {
      this.dialogVisible = true
    },
    onGrade(row) {
      this.fileleDialog = true
      QBRApi.getFileLists({
        tsReckindId: "PROTEIN_MEDICINE",
        tsRecId: row.ttRmcProteinMedicineId
      }).then(res => {
        this.fileList = res
      });
    },
    onAbarbeitung(row) {
      console.log("整改的数据=====", row)
      sessionStorage.setItem("taskDetail", JSON.stringify(row))
      this.$router.push({
        path: "/sponsormarkSheet",
        query: {

        }
      })
    },
    onReset() {
      this.queryCondition = {
        category3Code: "",
        sponsorName: "",
        aslGroupName: "",
        medicineLevelOneGrade: "",
        medicineLevelTwoGrade: "",
        whoMedicineGrade: "",
        effectiveComponentsList: [],
        commonName: "",
        productName: "",
        medicineUseStatus: "",
        status: "",
        pageNum: 1,
        pageSize: 15,
      }
      // this.$refs['queryCondition'].resetFields();
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    getDrugGrade() {
      proteinDrug.queryNatureForSelect().then((res) => {
        // 有效成分
        res.data.effectiveComponentsList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.effectiveComponentsList.push(obj)
        })
        // 药品一级分类
        res.data.medicineLevelOneGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.medicineLevelOneGradeList.push(obj)
        })
        // 药品二级分类
        res.data.medicineLevelTwoGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.medicineLevelTwoGradeList.push(obj)
        })
        // WHO药品等级
        res.data.whoMedicineGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.whoMedicineGradeList.push(obj)
        })
        // OIE药物等级
        res.data.oieMedicineGradeList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.oieMedicineGradeList.push(obj)
        })
        console.log("获取的所以药品分类====", res)
      })
    },
    closeExportDialog() {
      this.exportDialog = false
    },
    addList() {
      this.$router.push({
        path: "/rmcProtMedicine/detail",
        query: {

        }
      })
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    isUpdate() {
      // let strMsg=''
      // console.log("当前年月",moment().format("YYYY")+'/'+moment().format("MM")  )
      // if(moment().format('MM')==1||moment().format('MM')==2||moment().format('MM')==3){
      //   strMsg='评价期'+moment().add(-1, 'y').format("YYYY")+'Q4'+"已确认无更新"
      // }else{
      //   strMsg='评价期'+moment().format("YYYY")+' Q'+moment().add(-1, 'Q').quarter()+"已确认无更新"
      // }
      // console.log("11111111",strMsg)
      // let params={
      //   proteinMedicineIds:[]
      // }
      // this.multipleSelection.forEach((v)=>{
      //   params.proteinMedicineIds.push(v.ttRmcProteinMedicineId)
      // })
      proteinDrug.approveAndNoUpdate().then((res) => {
        if (res.code == 200) {
          this.$message.success(res.data)
          this.multipleSelection = []
          this.queryData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = false
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].status == 'PENDING' || this.multipleSelection[i].status == 'PASS') {
            isCreate = true
            break
          }
        }
        if (isCreate) {
          this.$message.error("仅可删除状态为草稿/退回的清单")
        } else {
          this.$confirm('请确认是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'colorBtn',
            cancelButtonClass: 'btn_custom_cancel',
            type: 'warning'
          }).then(() => {
            let params = {
              proteinMedicineIds: []
            }
            this.multipleSelection.forEach((v) => {
              params.proteinMedicineIds.push(v.ttRmcProteinMedicineId)
            })
            proteinDrug.deleteDrug(params).then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功")
                this.multipleSelection = []
                this.queryData()
              } else {
                this.$message.error(res.msg)
              }
            })
          })
        }
      }
    },
    exportMedicine() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttRmcProteinMedicineId)
      })
      this.queryCondition.proteinMedicineIds = ids
      proteinDrug.exportMedicine(this.queryCondition).then((res) => {
        fileService.respToFile(res, 'Protein_药品清单.xlsx');
      })
    },
    exportMedicineSnapshot() {
      this.exportTitle = 'Protein'
      this.exportType = '药品清单(季度)'
      this.exportDialog = true
    },
    approve() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = this.multipleSelection.some((v) => {
          return v.status != 'PENDING'
        })
        if (isCreate) {
          this.$message.error('只能操作待审批的数据')
        } else {
          let params = {
            proteinMedicineIds: []
          }
          this.multipleSelection.forEach((v) => {
            params.proteinMedicineIds.push(v.ttRmcProteinMedicineId)
          })
          proteinDrug.approverDrugList(params).then((res) => {
            if (res.code == 200) {
              this.$message.success("批准成功")
              this.multipleSelection = []
              this.queryData()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
    importData() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.importFileList = []
    },
    sendBack() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = this.multipleSelection.some((v) => {
          return v.status != 'PENDING'
        })
        if (isCreate) {
          this.$message.error('只能操作待审批的数据')
        } else {
          this.$prompt('', '请填写退回意见', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValidator: (value) => {
              if (!value) {
                return '退回意见不能为空！';
              }
            },
          }).then(({ value }) => {
            let params = {
              proteinMedicineIds: []
            }
            params.opinion = value
            this.multipleSelection.forEach((v) => {
              params.proteinMedicineIds.push(v.ttRmcProteinMedicineId)
            })
            proteinDrug.backDrugList(params).then((res) => {
              if (res.code == 200) {
                this.$message.success("退回成功")
                this.multipleSelection = []
                this.queryData()
              } else {
                this.$message.error(res.msg)
              }
            })

          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
        }
      }


    },
    submit() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = this.multipleSelection.some((v) => {
          return v.status == 'PENDING'
        })
        if (isCreate) {
          this.$message.error('待审批的数据不可提交')
        } else {
          let arr = []
          this.multipleSelection.forEach((v) => {
            if (!v.isExistFile && v.lastDetectionTime) {
              arr.push(v.productName + '药品检测报告未上传，请检查')
            }
          })
          let isExistFile = this.multipleSelection.some((v) => {
            return !v.isExistFile && v.lastDetectionTime
          })
          if (isExistFile) {   //证明有数据文件没上传
            const h = this.$createElement
            var valid = this.utils.validTable(arr, h)
            if (!valid) {
              return false
            }
          } else {
            let params = {
              proteinMedicineIds: []
            }
            this.multipleSelection.forEach((v) => {
              params.proteinMedicineIds.push(v.ttRmcProteinMedicineId)
            })
            proteinDrug.submitDrugList(params).then((res) => {
              if (res.code == 200) {
                this.$message.success('提交成功')
                this.multipleSelection = []
                this.queryData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      }


    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.dialogVisible = false
      this.queryData()
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
      })
    },

  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm /deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchForm /deep/ .el-tag__close.el-icon-close {
  top: -5px;
}
.searchForm /deep/ .el-select__tags {
  flex-wrap: nowrap !important;
}
.searchForm /deep/ .el-tag.el-tag--info {
  max-width: 110px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
